<template>
  <div :class="`pop-element ${plat}`" @click.stop>
    <div class="pop-search">
      <!-- :readonly="readonly" -->
      <input ref="search" class="pop-input" type="text" placeholder="搜索职位" :value="$store.state.postKeyWord"
        @input.stop="handleInput" @propertychange="handleInput" @compositionstart="handleInputStart"
        @compositionend="handleInputEnd" @click="toTop" />
      <span class="pop-icon">
        <img v-show="$store.state.plat === 'Web' && !activeIcon" src="../../assets/icon_search03.png" alt />
        <img v-show="$store.state.plat === 'Web' && activeIcon" src="../../assets/icon_search02.png" alt />
        <img v-show="$store.state.plat === 'Mobile' && !activeIcon" src="../../assets/icon_search03_m.png" alt />
        <img v-show="$store.state.plat === 'Mobile' && activeIcon" src="../../assets/icon_search02_m.png" alt />
      </span>
    </div>
    <div :style="msy" class="pop-typeOpt">
      <div :class="['pop-tItem', { 'active': ctrlTabActive.indexOf('1') !== -1 }]" @click="selectSalary">
        <span>岗位类别</span>
        <img class="img1" src="../../assets/icon_arrow01.png" alt />
        <img class="img2" src="../../assets/icon_arrow02.png" alt />
      </div>
      <div :class="['pop-tItem', { 'active': ctrlTabActive.indexOf('2') !== -1 }]" @click="selectType">
        <span>工作地点</span>
        <img class="img1" src="../../assets/icon_arrow01.png" alt />
        <img class="img2" src="../../assets/icon_arrow02.png" alt />
      </div>
      <div :class="['pop-tItem', { 'active': ctrlTabActive.indexOf('3') !== -1 }]" @click="selectComp">
        <span>所属公司</span>
        <img class="img1" src="../../assets/icon_arrow01.png" alt />
        <img class="img2" src="../../assets/icon_arrow02.png" alt />
      </div>
      <div :class="['pop-tList', { 'hide': $store.state.ctrlUnderLevelListHide === true }]">
        <ul :class="[{ 'hide': ctrlTypeHide === true }]">
          <li :class="['li-tr', { 'active': ($store.state.selectedSalaryArr.toString() || '0').indexOf(p.id) !== -1 }]"
            v-for="p of [{ id: '0', value: '不限' }].concat(postSalaryData)" :key="p.id" :data-value="p.id"
            @click.stop="salarySelector">{{ p.value }}</li>
        </ul>
        <ul :class="[{ 'hide': ctrlAddrHide === true }]">
          <li :class="['li-tr', { 'active': ($store.state.selectedTypeArr.toString() || '0').indexOf(p.value) !== -1 }]"
            v-for="p of [{ id: '0', value: '不限' }].concat(postTypeData)" :key="p.key" :data-value="p.value"
            @click.stop="typeSelector">{{ p.value }}</li>
        </ul>
        <ul :class="[{ 'hide': ctrlCompHide === true }]">
          <li
            :class="['li-tr', { 'active': ($store.state.selectedCompanyArr.toString() || '0').split(',').indexOf(p.umsId) !== -1 }]"
            v-for="p of [{ umsId: '0', abbreviation: '不限' }].concat(postCompanyData)" :key="p.key" :data-value="p.umsId"
            @click.stop="compySelector">{{ p.abbreviation }}</li>
        </ul>
      </div>
    </div>
    <ul class="pop-ulList" :style="psy">
      <li class="li-th">岗位类别</li>
      <li class="li-tr" v-for="p of postSalaryData" :key="p.id">
        <label :for="`type-${p.id}`">
          <input :id="`type-${p.id}`" type="checkbox" name="postType"
            :checked="($store.state.selectedSalaryArr.toString() || '0').indexOf(p.id) !== -1" :data-value="p.id"
            @change.stop="salarySelector" />
          <span>
            <img class="check01" src="../../assets/icon_checkbox01.png" alt />
            <img class="check02" src="../../assets/icon_checkbox02.png" alt />
          </span>
          <span>{{ p.value }}</span>
        </label>
      </li>
    </ul>
    <ul class="pop-ulList" :style="psy">
      <li class="li-th">工作地点</li>
      <li class="li-tr" v-for="p of postTypeData" :key="p.id">
        <label :for="`type-${p.id}`">
          <input :id="`type-${p.id}`" type="checkbox" name="postType"
            :checked="($store.state.selectedTypeArr.toString() || '0').indexOf(p.value) !== -1" :data-value="p.value"
            @change.stop="typeSelector" />
          <span>
            <img class="check01" src="../../assets/icon_checkbox01.png" alt />
            <img class="check02" src="../../assets/icon_checkbox02.png" alt />
          </span>
          <span>{{ p.value }}</span>
        </label>
      </li>
    </ul>
    <ul class="pop-ulList" :style="psy">
      <li class="li-th">所属公司</li>
      <li class="li-tr" v-for="p of postCompanyData" :key="p.umsId">
        <label :for="`type-${p.umsId}`">
          <input :id="`type-${p.umsId}`" type="checkbox" name="postType"
            :checked="($store.state.selectedCompanyArr.toString() || '0').split(',').indexOf(p.umsId) !== -1"
            :data-value="p.umsId" @change.stop="compySelector" />
          <span>
            <img class="check01" src="../../assets/icon_checkbox01.png" alt />
            <img class="check02" src="../../assets/icon_checkbox02.png" alt />
          </span>
          <span>{{ p.abbreviation }}</span>
        </label>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  // 本组件自定义的属性
  props: {
    readonly: Boolean,
    seat: String,
  },
  data() {
    return {
      ctrlTypeHide: true,
      ctrlAddrHide: true,
      ctrlCompHide: true,
      ctrlTabActive: [],
      plat: `plat-${this.$store.state.plat}`,
      psy: { display: this.$store.state.plat === 'Web' ? '' : 'none' },
      msy: { display: this.$store.state.plat === 'Mobile' ? '' : 'none' },
      activeIcon: false,
      postSalaryData: [],
      postTypeData: [],
      postCompanyData: [],
      tFlag: false
    }
  },
  mounted() {
    if (this.$store.state.activeTopTab == 4) {
      this.getPostSort(1)
      this.getJob()
      this.getWorkPlace(1)
    } else {
      this.getPostSort(2)
      this.getJob()
      this.getWorkPlace(2)
    }

  },
  methods: {
    toTop() {
      if (this.$store.state.plat === 'Mobile' && this.seat === 'In') {
        let offTop = document.querySelector('.page-02').offsetTop
        document.getElementById('main-can-scroll').scrollTop = offTop + 5
        // document.querySelector('#highest-level .pop-input').focus();
        return;
      }
    },
    handleInputStart() {
      this.tFlag = true;
    },
    handleInputEnd(e) {
      this.tFlag = false;
      this.handleInput(e);
    },
    handleInput(e) {
      if (!this.tFlag) {
        const keyw = e.target.value;
        if (!!keyw) {
          this.activeIcon = true
        } else {
          this.activeIcon = false
        }
        if (this.$store.state.plat === 'Mobile') {
          document.querySelectorAll('.page-02 .pop-search .pop-icon img').forEach((ele, k) => {
            if (k === 2) {
              ele.style.display = !!keyw ? 'none' : 'inline-block'
            }
            if (k === 3) {
              ele.style.display = !!keyw ? 'inline-block' : 'none'
            }
          })
          document.getElementById('main-can-scroll').scrollTop = document.querySelector('.page-02').offsetTop + 2
        }
        this.$store.commit('setShowedPost', keyw)
      }
    },
    handleCategory(cate, val) {
      if (val !== "0") {
        let index = this.$store.state[cate].indexOf(val);
        if (index === -1) {
          this.$store.state[cate].push(val);
        } else {
          this.$store.state[cate].splice(index, 1);
        }
      } else {
        this.$store.state[cate] = [];
      }
      this.$store.commit('setShowedPost', undefined);
    },
    handleCategoryType(cate, val) {
      if (val !== "不限") {
        let index = this.$store.state[cate].indexOf(val);
        if (index === -1) {
          this.$store.state[cate].push(val);
        } else {
          this.$store.state[cate].splice(index, 1);
        }
      } else {
        this.$store.state[cate] = [];
      }
      this.$store.commit('setShowedPost', undefined);
    },
    salarySelector(e) {
      // console.log(e)
      let tg = e.target
      let tp = tg.parentElement
      let val = tg.dataset.value
      if (this.$store.state.plat === 'Mobile') {
        if (tg.classList.contains('active')) {
          if (val !== '0') {
            tg.classList.remove('active')
            let flag = false;
            for (let i = 1; i < tp.children.length; i++) {
              if (tp.children[i].classList.contains('active')) {
                flag = true;
              }
            }
            if (!flag) {
              val = '0'
              tp.firstElementChild.classList.add('active')
            }
          }
        } else {
          tg.classList.add('active')
          if (val !== '0') {
            tp.firstElementChild.classList.remove('active')
          } else {
            for (let i = 1; i < tp.children.length; i++) {
              tp.children[i].classList.remove('active')
            }
          }
        }
        // console.log("this.ctrlTabActive:", this.ctrlTabActive)
        this.ctrlTabActive = (this.ctrlTabActive.join('').replace(/1/, '') + (val === '0' ? '0' : '1')).split('');
        // console.log("this.ctrlTabActive:", this.ctrlTabActive)
      }
      this.handleCategory('selectedSalaryArr', val);
    },
    typeSelector(e) {
      let tg = e.target
      let tp = tg.parentElement
      let val = tg.dataset.value
      console.log(this.$store.state.plat)
      if (this.$store.state.plat === 'Mobile') {
        if (tg.classList.contains('active')) {
          if (val !== '不限') {
            tg.classList.remove('active')
            let flag = false;
            for (let i = 1; i < tp.children.length; i++) {
              if (tp.children[i].classList.contains('active')) {
                flag = true;
              }
            }
            if (!flag) {
              val = '不限'
              tp.firstElementChild.classList.add('active')
            }
          }
        } else {
          tg.classList.add('active')
          if (val !== '不限') {
            tp.firstElementChild.classList.remove('active')
          } else {
            for (let i = 1; i < tp.children.length; i++) {
              tp.children[i].classList.remove('active')
            }
          }
        }
        // console.log("this.ctrlTabActive:", this.ctrlTabActive)
        // console.log("val:", val)
        this.ctrlTabActive = (this.ctrlTabActive.join('').replace(/2/, '') + (val === '不限' ? '0' : '2')).split('');
        // console.log("this.ctrlTabActive:", this.ctrlTabActive)
      }
      this.handleCategoryType('selectedTypeArr', val);
    },
    compySelector(e) {
      let tg = e.target
      let tp = tg.parentElement
      let val = tg.dataset.value
      if (this.$store.state.plat === 'Mobile') {
        if (tg.classList.contains('active')) {
          if (val !== '0') {
            tg.classList.remove('active')
            let flag = false;
            for (let i = 1; i < tp.children.length; i++) {
              if (tp.children[i].classList.contains('active')) {
                flag = true;
              }
            }
            if (!flag) {
              val = '0'
              tp.firstElementChild.classList.add('active')
            }
          }
        } else {
          tg.classList.add('active')
          if (val !== '0') {
            tp.firstElementChild.classList.remove('active')
          } else {
            for (let i = 1; i < tp.children.length; i++) {
              tp.children[i].classList.remove('active')
            }
          }
        }
        this.ctrlTabActive = (this.ctrlTabActive.join('').replace(/3/, '') + (val === '0' ? '0' : '3')).split('');
      }
      this.handleCategory('selectedCompanyArr', val);
    },
    selectSalary() {
      // this.ctrlTabActive = (this.ctrlTabActive.join('').replace(/1/, '') + '1').split('');
      if (this.seat === 'In') {
        let offTop = document.querySelector('.page-02').offsetTop
        document.getElementById('main-can-scroll').scrollTop = offTop + 5
        document.querySelector('#highest-level .pop-typeOpt .pop-tItem:first-child').click();
        return;
      }
      // if (this.seat === 'Out') {
      //  }
      let actFlag = true;
      let page2Elem = document.querySelectorAll('.page-02 .pop-typeOpt .pop-tItem')
      for (let i = 0; i < page2Elem.length; i++) {
        if (i === 0 && !page2Elem[i].classList.contains('active')) actFlag = false;
        page2Elem[i].classList[i === 0 ? 'add' : 'remove']('active')
      }
      let curState = this.$store.state.ctrlUnderLevelListHide
      this.ctrlTypeHide = false
      this.ctrlAddrHide = true
      this.ctrlCompHide = true
      this.$store.commit('setLevelHide', actFlag ? !curState : false);

    },
    selectType() {
      // this.ctrlTabActive = (this.ctrlTabActive.join('').replace(/2/, '') + '2').split('');
      if (this.seat === 'In') {
        let offTop = document.querySelector('.page-02').offsetTop
        document.getElementById('main-can-scroll').scrollTop = offTop + 5
        document.querySelector('#highest-level .pop-typeOpt .pop-tItem:nth-child(2)').click();
        return;
      }
      // if (this.seat === 'Out') {
      // }
      let actFlag = true;
      let page2Elem = document.querySelectorAll('.page-02 .pop-typeOpt .pop-tItem')
      for (let i = 0; i < page2Elem.length; i++) {
        if (i === 1 && !page2Elem[i].classList.contains('active')) actFlag = false;
        page2Elem[i].classList[i === 1 ? 'add' : 'remove']('active')
      }
      let curState = this.$store.state.ctrlUnderLevelListHide
      this.ctrlTypeHide = true
      this.ctrlAddrHide = false
      this.ctrlCompHide = true
      this.$store.commit('setLevelHide', actFlag ? !curState : false);
    },
    selectComp() {
      // this.ctrlTabActive = (this.ctrlTabActive.join('').replace(/2/, '') + '2').split('');
      if (this.seat === 'In') {
        let offTop = document.querySelector('.page-02').offsetTop
        document.getElementById('main-can-scroll').scrollTop = offTop + 5
        document.querySelector('#highest-level .pop-typeOpt .pop-tItem:nth-child(3)').click();
        return;
      }
      // if (this.seat === 'Out') {
      // }
      let actFlag = true;
      let page2Elem = document.querySelectorAll('.page-02 .pop-typeOpt .pop-tItem')
      for (let i = 0; i < page2Elem.length; i++) {
        if (i === 2 && !page2Elem[i].classList.contains('active')) actFlag = false;
        page2Elem[i].classList[i === 2 ? 'add' : 'remove']('active')
      }
      let curState = this.$store.state.ctrlUnderLevelListHide
      this.ctrlTypeHide = true
      this.ctrlAddrHide = true
      this.ctrlCompHide = false
      this.$store.commit('setLevelHide', actFlag ? !curState : false);
    },
    getPostSort(type = 1) {
      let that = this
      this.$request({
        api: '/uhrm/website/belongToCompany',
        type: 'GET',
        param: {
          type: type
        },
        success: function (res) {
          console.info(res)
          that.postCompanyData = res
        },
        error: function (err) {
          console.log('失败1。。', err)
        }
      })
    },
    getJob() {
      let that = this
      this.$request({
        api: '/uhrm/website/jobCategoryDropDown',
        type: 'GET',
        param: {},
        success: function (res) {
          console.info(res)
          that.postSalaryData = res
        },
        error: function (err) {
          console.log('失败1。。', err)
        }
      })
    },
    getWorkPlace(type = 1) {
      let that = this
      this.$request({
        api: '/uhrm/website/workPlace',
        type: 'GET',
        param: {
          type: type
        },
        success: function (res) {
          console.info(res)
          that.postTypeData = res
        },
        error: function (err) {
          console.log('失败1。。', err)
        }
      })
    },
  },
  watch: {
    '$store.state.activeTopTab'(newVal, oldVal) {
      //对数据执行操作
      if (this.$store.state.plat === 'Mobile') {
        if (newVal == 4) {
          this.getPostSort(1)
          this.getJob()
          this.getWorkPlace(1)
        } else {
          this.getPostSort(2)
          this.getJob()
          this.getWorkPlace(2)
        }
      }
    }
  }
}
</script>

<style lang="less" rel="stylesheet/less" scoped>
@import "../../components/common/common.less";

.pop-element {
  background: #fff;
  padding: 20px 16px;
  box-sizing: border-box;
  width: 100%;

  &.plat-Mobile {
    .pop-typeOpt {
      height: max-content;

      .pop-tList {
        float: left;
        width: 100%;

        &.hide {
          display: none;
        }

        ul {
          line-height: 30px;
          padding-top: 20px;

          &.hide {
            display: none;
          }

          li {
            line-height: 45px;

            &.active {
              color: #ff5f00;
            }
          }
        }
      }

      .pop-tItem {
        float: left;
        background: #f5f6f7;
        color: #666666;
        height: 33px;
        border-radius: 33px;
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0 14px;
        margin: 0 8px 0 0;

        &.active {
          background: rgba(255, 95, 0, 0.15);
          color: #ff5f00;

          &>img.img1 {
            display: none;
          }

          &>img.img2 {
            display: inline-block;
          }
        }

        &>span {
          margin-right: 8px;
        }

        &>img {
          width: 10px;
        }

        &>img.img1 {
          display: inline-block;
        }

        &>img.img2 {
          display: none;
        }
      }

      @media (min-width: 360px) {
        .pop-tItem {
          padding: 0 8px;
          font-size: 12px;
        }
      }

      @media (min-width: 400px) {
        .pop-tItem {
          padding: 0 14px;
          font-size: 14px;
        }
      }

      &::after {
        content: " ";
        display: block;
        clear: both;
      }
    }

    .pop-search {
      height: 44px;
      line-height: 44px;

      input {
        border-radius: 44px;
        padding: 0 0 0 38px;
      }

      .pop-icon {
        width: 18px;
        position: absolute;
        top: 0px;
        left: 10px;
        z-index: 10;
        cursor: pointer;

        img {
          width: 100%;
        }
      }
    }
  }

  // 搜索栏
  .pop-search {
    width: 100%;
    height: 38px;
    line-height: 38px;
    position: relative;
    margin-bottom: 20px;

    input {
      width: 100%;
      height: 100%;
      border: none;
      outline: none;
      border-radius: 5px;
      padding: 0 30px 0 8px;
      background: #f5f5f5;
      box-sizing: border-box;
      .cmPlaceholder(#999, 12px);
    }

    .pop-icon {
      width: 18px;
      position: absolute;
      top: 0;
      right: 6px;
      z-index: 10;
      cursor: pointer;

      img {
        width: 100%;
      }
    }
  }

  // 岗位类别
  .pop-ulList {
    margin-bottom: 20px;

    &:last-child {
      margin: 0;
    }

    .li-th {
      color: #1f2329;
      font-size: 16px;
      font-weight: bold;
    }

    .li-tr {
      // color:
      margin-top: 12px;

      label {
        cursor: pointer;

        .check01 {
          width: 14px;
          display: inline-block;
          // transform: translateY(2px);
        }

        .check02 {
          width: 14px;
          display: none;
          // transform: translateY(2px);
        }

        input[type="checkbox"] {
          display: none;

          &:checked+span {
            .check01 {
              display: none;
            }

            .check02 {
              display: inline-block;
            }
          }
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/s-input/s-input.vue